import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class DevicesService {

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) { }

  getDevices(limit?) {
    let config = {
        headers: new HttpHeaders({'Content-Type':'application/json'})
      };
      if(limit) {
        config["params"] = {
          filter: JSON.stringify({"limit": limit})
        };
      } else {
        config["params"] = {
            filter: JSON.stringify({"limit": 500})
          };
      }
      return this.http.get('/devices', config);
  }
  
  searchDevices(query) {
      return this.http.get('/devices/search?q='+query);
  }

  createDevice(data) {
      let body = JSON.stringify(data);
      return this.http.post('/devices/', body, this.httpOptions);
  }

  updateDevice(data) {
      let body = JSON.stringify(data);
      return this.http.put('/devices/' + data.id, body, this.httpOptions);
  }

  deleteDevice(data) {
      return this.http.delete('/devices/' + data.id);
  }

  getCount(){
    return this.http.get('/devices/count');
  }

  getDeviceById(id) {
    let q = JSON.stringify({"where": {"id": id }});
    return this.http.get('/devices?filter='+q);
  }

  getVehicleAssociationByDeviceId(deviceId): any {
    let config = {
      headers: new HttpHeaders({'Content-Type':'application/json'})
    };

    if(deviceId) {
      config["params"] = {
        filter: JSON.stringify({ "where": { "deviceId" : deviceId  }, order: "associatedDate DESC", limit: "1" })
      };
    }

    return this.http.get('/VehicleDevices', config);
  }
  
  getVehicleAssociationByVehicleId(vehicleId): any {
    let config = {
      headers: new HttpHeaders({'Content-Type':'application/json'})
    };

    if(vehicleId) {
      config["params"] = {
        filter: JSON.stringify({ "where": { "vehicleId" : vehicleId  }, order: "associatedDate DESC", limit: "1" })
      };
    }

    return this.http.get('/VehicleDevices', config);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/devices/devices.service.ts